// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  // Icon,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogActions,
  // IconButton,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
// import { useEffect, useState, useRef } from "react";
import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

// import { toPng } from "html-to-image";
// import QRCode from "react-qr-code";

// import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function AffiliateLinks() {
  const pageTitle = "Sell Links";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  // const qrCodeRef = useRef(null);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  // const [openCopySnackBar, setOpenSnackBar] = useState(false);
  // async function copy(voucher) {
  //   try {
  //     await navigator.clipboard.writeText(voucher);
  //     setOpenSnackBar(true);
  //   } catch (err) {
  //     console.error("Failed to copy: ", err);
  //   }
  // }

  const [paylinks, setPaylinks] = useState([]);
  // const [selectedLink, setSelectedLink] = useState(null);
  // const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);

  // function downloadQRCode() {
  //   toPng(qrCodeRef.current)
  //     .then((dataUrl) => {
  //       const link = document.createElement("a");
  //       link.href = dataUrl;
  //       link.download = `${selectedLink.campaign.account.name} - ${selectedLink.campaign.title}.png`;
  //       link.click();
  //     })
  //     .catch((error) => {
  //       console.error("Error generating QR code:", error);
  //     });
  // }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/campaigns/affiliate_links.json")
        .then((result) => {
          // console.log(result.data.data.paylinks);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPaylinks(result.data.data.paylinks);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  // function shareLink(platform, afLink) {
  //   const link = afLink.paylink;
  //   let msg = `Buy now using my Affiliate Link.`;
  //   msg = `*${encodeURIComponent(afLink.campaign.title)}*%0a${encodeURIComponent(
  //     msg
  //   )}%0a%0a${encodeURIComponent(link)}%0a%0a*Powered by Laddar Africa*`;
  //   let url = "";
  //   if (platform === "whatsapp") {
  //     url = `whatsapp://send?text=${msg}`;
  //   } else {
  //     url = `https://t.me/share/url?url=${msg}`;
  //   }
  //   window.open(url, "_blank");
  // }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {/* <Snackbar
        autoHideDuration={5000}
        onClose={() => setOpenSnackBar(false)}
        open={openCopySnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Copied
        </Alert>
      </Snackbar> */}
      {/* {selectedLink ? (
        <Dialog open={openQRCodeDialog}>
          <DialogTitle>
            <MDBox>QR Code</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox p={2} ref={qrCodeRef}>
              <QRCode value={selectedLink.paylink} size={180} />
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenQRCodeDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
            <MDButton
              onClick={() => downloadQRCode()}
              color="success"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )} */}

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          My Sell Links
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" mt={2}>
                          Sell online to anyone, anywhere. Monetise your online social network by
                          sharing your unique sell links.
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={5}>
                  {paylinks.map((link) => (
                    <MDBox mb={2}>
                      <Card
                        sx={{ height: "100%", marginTop: "0px" }}
                        onClick={() => navigate(`/affiliate-links/${link.reference}`)}
                      >
                        <MDBox p={3}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={10} lg={10}>
                              <MDBox align="left">
                                <MDBox mt={-1}>
                                  <MDTypography variant="button" color="info" fontWeight="light">
                                    <img
                                      src={`${AppConfig.api_media_url}${link.campaign.account.icon}`}
                                      alt=""
                                      width="24px"
                                    />
                                    &nbsp; &nbsp;{link.campaign.account.name}
                                  </MDTypography>
                                </MDBox>
                                <MDBox>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {link.campaign.title}
                                  </MDTypography>
                                </MDBox>
                                {/* <MDBox>
                                  <MDTypography variant="caption" fontWeight="light">
                                    <a href={link.paylink} target="_blank" rel="noreferrer">
                                      {link.paylink}
                                    </a>
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  ml={-1}
                                  mt={0}
                                  display="flex"
                                  justifyContent="start"
                                  alignItems="start"
                                >
                                  <IconButton
                                    size="large"
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => copy(link.paylink)}
                                  >
                                    <Icon>copy</Icon>
                                  </IconButton>
                                  <a href={link.paylink} target="_blank" rel="noreferrer">
                                    <IconButton size="large" variant="outlined" color="dark">
                                      <Icon>send</Icon>
                                    </IconButton>
                                  </a>
                                  <IconButton
                                    onClick={() => {
                                      setSelectedLink(link);
                                      setOpenQRCodeDialog(true);
                                    }}
                                    color="info"
                                    size="large"
                                  >
                                    <Icon>qr_code</Icon>
                                  </IconButton>
                                  <IconButton
                                    size="large"
                                    onClick={() => shareLink("whatsapp", link)}
                                  >
                                    <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                                  </IconButton>
                                  <IconButton
                                    size="large"
                                    onClick={() => shareLink("telegram", link)}
                                  >
                                    <Icon color="info">telegram</Icon>
                                  </IconButton>
                                </MDBox> */}
                              </MDBox>
                            </Grid>
                            {/* <Grid item xs={12} md={2} lg={2}>
                              <MDTypography align="center">
                                <MDButton
                                  onClick={() => {
                                    setSelectedLink(link);
                                    setOpenQRCodeDialog(true);
                                  }}
                                  color="info"
                                  variant="outlined"
                                  circular
                                  iconOnly
                                >
                                  <Icon>qr_code</Icon>
                                </MDButton>
                                &nbsp;
                                <MDButton
                                  onClick={() => {
                                    copy(link.paylink);
                                  }}
                                  color="success"
                                  variant="outlined"
                                  circular
                                  iconOnly
                                >
                                  <Icon>content_copy</Icon>
                                </MDButton>
                              </MDTypography>
                            </Grid> */}
                          </Grid>
                        </MDBox>
                      </Card>
                    </MDBox>
                  ))}
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AffiliateLinks;
